// Routes temporarily hidden from all users (feature not released yet).
// Hidden from the sidebar AND blocked at the route level (redirect to /dashboard).
export const HIDDEN_ROUTE_PREFIXES: string[] = [
  "/cash-count",                     // فحص فوري للخزينة
  "/purchases/orders",               // عروض أسعار الشراء
  "/inventory/pending-revaluation",  // إعادة تسعير معلقة
  "/inventory/period-close",         // إقفال فترة المخزون
  "/inventory/integrity",            // فحص سلامة المخزون
  "/cip",                            // مشروعات تحت التنفيذ
  "/asset-custody-transfer",         // نقل عهد عينية
  "/cash-custody",                   // تسوية عهد نقدية
  "/accruals",                       // مصروفات مستحقة
];

export function isHiddenRoute(pathname: string): boolean {
  return HIDDEN_ROUTE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));
}
